import {
  signFinishChart,
  applyStatusBarChart,
  contractTypeChart,
  applyTrendBarChart
} from '@/apis/installation/workbench'
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    // 报装签约完成情况
    sign() {
      let obj = { timeFlag: this.signType }
      if (this.signType == 1) {
        obj.startTime = this.signTime[0]
        obj.endTime = this.signTime[1]
      }
      signFinishChart(obj).then(res => {
        if (res.code == 200) {
          this.signData = res.data
          this.getSignEchart(res.data)
        }
      })
    },
    getSignEchart(qxzbData) {
      // let qxzbData = [
      //   {
      //     name: '已完结',
      //     value: 500,
      //     full: 1000 // 最大值
      //   },
      //   {
      //     name: '已签约',
      //     value: 756,
      //     full: 1000
      //   },
      //   {
      //     name: '报装申请总量',
      //     value: 1000,
      //     full: 1000
      //   }
      // ]
      let option = {
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        // tooltip: {
        //   trigger: 'item'
        // },
        legend: {
          orient: 'vertical',
          right: 20,
          y: 'center',
          itemHeight: 13,
          itemWidth: 18,
          textStyle: {
            fontSize: 14
          },
          data: qxzbData,
          itemGap: 30
        },
        color: ['#6748FE', '#5FD7A7', '#029DFB'],
        series: [
          {
            name: qxzbData[2].name, //最里面的圈
            type: 'pie',
            clockWise: true, //顺时加载
            radius: ['30%', '38%'],
            center: ['35%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              emphasis: {
                show: false
              }
            },
            data: [
              {
                value: qxzbData[2].value,
                name: qxzbData[2].name,
                label: {
                  formatter: '{d}%',
                  show: true,
                  position: 'inner',
                  fontSize: 18,
                  fontWeight: 'bold',
                  color: '#000'
                },
                itemStyle: {
                  borderRadius: ['50%', '50%']
                }
              },
              {
                value: qxzbData[2].full - qxzbData[2].value,
                itemStyle: {
                  normal: {
                    color: '#E1F1FF'
                  }
                }
              }
            ]
          },
          {
            tooltip: {
              trigger: 'item'
            },
            name: qxzbData[1].name, //第二个圈
            type: 'pie',
            clockWise: true, //顺时加载
            radius: ['55%', '63%'],
            center: ['35%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              emphasis: {
                show: false
              }
            },
            data: [
              {
                value: qxzbData[1].value,
                name: qxzbData[1].name,
                label: {
                  formatter: '{d}%',
                  show: true,
                  position: 'inner',
                  fontSize: 18,
                  fontWeight: 'bold'
                },
                itemStyle: {
                  borderRadius: ['50%', '50%']
                }
              },
              {
                value: qxzbData[1].full - qxzbData[1].value,
                itemStyle: {
                  normal: {
                    color: '#E1F1FF'
                  }
                }
              }
            ]
          },
          {
            name: qxzbData[0].name, //最外层圈
            type: 'pie',
            clockWise: true, //顺时加载
            radius: ['80%', '88%'],
            center: ['35%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              emphasis: {
                show: false
              }
            },
            data: [
              {
                value: 1,
                name: '报装申请总量'
              },
              {
                value: 0,
                itemStyle: {
                  normal: {
                    color: '#E1F1FF'
                  }
                }
              }
            ]
          }
        ]
      }
      this.signEcharts.setOption(option, true)
    },
    // 报装申请状态统计
    apply() {
      let obj = { timeFlag: this.applyType }
      if (this.applyType == 1) {
        obj.startTime = this.applyTime[0]
        obj.endTime = this.applyTime[1]
      }
      applyStatusBarChart(obj).then(res => {
        if (res.code == 200) {
          let allData = res.data
          let allNumber = 0
          allData.series[0]['data'].forEach(item => {
            allNumber += item
          })
          allData.allNumber = allNumber
          this.getApplyEchart(allData)
        }
      })
    },
    getApplyEchart(echartData) {
      let option = {
        grid: {
          top: '30',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        xAxis: {
          type: 'category',
          data: echartData.xaxis['data']
        },
        yAxis: {
          // name: '百分比（%）',
          type: 'value',
          nameTextStyle: {
            padding: [0, 0, 0, 20]
          }
        },
        color: ['#7984F3', '#91CC75', '#219CF9', '#FE7A7A'],
        series: [
          {
            color: ['#7984F3', '#91CC75', '#219CF9', '#FE7A7A'],
            data: echartData.series[0]['data'],
            colorBy: 'data',
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            barWidth: 40,
            label: {
              show: true,
              position: 'top',
              formatter: function(val) {
                if (val.value) {
                  let num = val.value / echartData.allNumber
                  let str = (num * 100).toFixed(2) + '%'
                  return str
                } else {
                  return '0%'
                }
              }
            }
          }
        ]
      }
      this.applyEcharts.setOption(option, true)
    },
    // 安装合同类型占比
    contract() {
      let obj = { timeFlag: this.contractType }
      if (this.contractType == 1) {
        obj.startTime = this.contractTime[0]
        obj.endTime = this.contractTime[1]
      }
      contractTypeChart(obj).then(res => {
        if (res.code == 200) {
          // return
          if (res.data && res.data.length) {
            let data = [...res.data]
            let arr = []
            for (let i = 0; i < data.length; i++) {
              arr.push({
                value: 0,
                name: '',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  normal: {
                    color: '#fff'
                  }
                }
              })
            }
            data = [...data, ...arr]
            this.getContractEchart(data)
          } else {
            this.contractEcharts.clear()
          }
        }
      })
    },
    getContractEchart(echartData) {
      let that = this
      let option = {
        legend: {
          orient: 'vertical',
          top: 'center',
          left: '10',
          itemHeight: 13,
          itemWidth: 18,
          textStyle: {
            fontSize: 14
          },
          itemGap: 27
        },
        grid: {
          top: '10',
          left: '0',
          right: '0',
          bottom: '0'
          // containLabel: true
        },
        series: [
          {
            // name: 'Access From',
            // type: 'pie',
            // radius: ['40%', '100%'],
            // center: ['55%', '30%'],
            // // adjust the start and end angle
            // startAngle: 50,
            // endAngle: 130,
            // roseType: 'area',
            // // itemStyle: {
            // //   borderRadius: 8
            // // },
            // label: {
            //   // alignTo: 'edge',
            //   color: 'inherit',
            //   formatter: '{name|{b}}\n{time|{c} }',
            //   lineHeight: 35,
            //   minMargin: 5,
            //   edgeDistance: 10,
            //   rich: {
            //     name: {
            //       fontSize: 16,
            //       fontWeight: 'bold',
            //       color: '#000'
            //     },
            //     time: {
            //       fontSize: 16,
            //       fontWeight: 'bold'
            //     }
            //   }
            // },
            // labelLine: {
            //   length: 15,
            //   length2: 0,
            //   maxSurfaceAngle: 80
            // },
            // labelLayout: function(params) {
            //   const isLeft = params.labelRect.x < that.contractEcharts.getWidth() / 2
            //   const points = params.labelLinePoints
            //   // Update the end point.
            //   points[2][0] = isLeft
            //     ? params.labelRect.x
            //     : params.labelRect.x + params.labelRect.width
            //   return {
            //     labelLinePoints: points
            //   }
            // },
            name: 'Access From',
            type: 'pie',
            radius: [37, 200],
            avoidLabelOverlap: false,
            center: ['50.1%', '0%'],
            startAngle: 0,
            roseType: 'area',
            selectedMode: 'single',
            label: {
              // alignTo: 'edge',
              color: 'inherit',
              formatter: '{name|{b}}\n{time|{c} }',
              lineHeight: 35,
              minMargin: 5,
              edgeDistance: 10,
              rich: {
                name: {
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#000'
                },
                time: {
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              //   length: 15,
              // length2: 0,
              // maxSurfaceAngle: 80,
              normal: {
                show: true,
                smooth: false,
                length: 15,
                length2: 0
              },
              emphasis: {
                show: true
              }
            },
            labelLayout: function(params) {
              const isLeft = params.labelRect.x < that.contractEcharts.getWidth() / 2
              const points = params.labelLinePoints
              // Update the end point.
              if (points && points[2]) {
                points[2][0] = isLeft
                  ? params.labelRect.x
                  : params.labelRect.x + params.labelRect.width
              }
              return {
                labelLinePoints: points
              }
            },
            data: echartData
          }
        ]
      }
      this.contractEcharts.setOption(option, true)
    },
    // 报装申请趋势
    trend() {
      applyTrendBarChart({ timeFlag: this.applySelect }).then(res => {
        if (res.code == 200) {
          // applySelect除了1，都需倒序
          let allData = res.data
          if (!this.tb) {
            allData.series.splice(1, 1)
          }
          if (this.applySelect != 1) {
            allData.series.forEach(item => {
              item.stack = 'Total'
              item.data = item.data.reverse()
            })
            allData.xaxis.data = allData.xaxis.data.reverse()
          }
          this.getTrendEchart(allData)
        }
      })
    },
    getTrendEchart(echartData) {
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          left: '160',
          top: '28',
          itemHeight: 1,
          itemWidth: 24,
          textStyle: {
            fontSize: 14,
            color: '#686C87'
          },
          data: ['cur', 'pre']
        },
        grid: {
          top: '88',
          left: '30',
          right: '30',
          bottom: '22',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: echartData.xaxis.data
        },
        yAxis: {
          type: 'value',
          boundaryGap: false
        },
        series: echartData.series
        // [
        //   {
        //     name: 'cur',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: 'pre',
        //     type: 'line',
        //     stack: 'Total',
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   }
        // ]
      }
      this.trendEcharts.setOption(option, true)
    }
  }
}
